import React, { useEffect, useState } from "react";
import "./index.css";
import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { onChangeToNumber } from "../../../../utils/helperFunction";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUsers,
  setFormDataQuickReportItemAdd,
} from "../../../../redux/slice/QuickReportSlice";
import QuantityCard from "../common/quantityCard";
import KitImagePreview from "../KitDetails/KitImagePreview";
import SelectWithTextfield from "../../../../components/Common/MUI/SelectWithTextfield";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";
const OnlineQuickPageTwo = () => {
  const navigate = useNavigate();
  const {
    quickAddItemFormData,
    quichReportData,
    usersList,
    injuryType,
    form_Data,
  } = useSelector((state) => state.QUICKREPORT);
  const dispatch = useDispatch();
  // main state of form
  const [formData, setFormData] = useState(quickAddItemFormData);
  const [users, setUsers] = useState([]);
  //onchange function to manipulate the state of the form data on change of input field
  //@@parm is event
  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "quantity") {
      const currentProduct = quichReportData?.products?.find(
        (item) => item._id === formData?.item?.productId
      );
      if (currentProduct) {
        const numericValue = Number(value);
        if (numericValue <= currentProduct?.current_quantity) {
          setFormData((prev) => ({
            ...prev,
            [name]: { value: value, warning: !value ? true : false },
          }));
        } else {
          toast.error(
            `Quantity must be less then or equal to ${currentProduct?.current_quantity}`
          );
        }
      } else {
        toast.error(`Please Select product`);
      }
    } else if (name === "item") {
      const product = quichReportData?.products?.find(
        (curElm) => curElm.description === value
      );
      setFormData((prev) => ({
        ...prev,
        [name]: {
          value: value,
          productId: product?._id,
          warning: !value ? true : false,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: { value: value, warning: !value ? true : false },
      }));
    }
  };

  // validate the form
  const validateForm = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      item: { ...data.item, warning: !data.item.value },
      quantity: { ...data.quantity, warning: !data.quantity.value },
      personOfTreatment: {
        ...data.personOfTreatment,
        warning: !data.personOfTreatment.value,
      },
    };
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
    if (
      !data.item.warning &&
      !data.quantity.warning &&
      !data.personOfTreatment.warning
    ) {
      setFormData((prev) => ({
        ...prev,
        formDataArray: [
          ...prev.formDataArray,
          {
            item: data.item,
            quantity: data.quantity,
            personOfTreatment: data.personOfTreatment,
          },
        ],
        // Reset form fields
        item: { value: "", warning: false },
        quantity: { value: "", warning: false },
        productId: "",
      }));
    }
  };

  // validate whole form
  const validateWholeFormValue = () => {
    // if (
    //   !formData.item.warning &&
    //   !formData.quantity.warning &&
    //   !formData.personOfTreatment.warning &&
    //   formData.formDataArray.length != 0
    // )
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        item: { value: "", warning: false },
        quantity: { value: "", warning: false },
        personOfTreatment: { value: "", warning: false },
        productId: "",
      };
      dispatch(setFormDataQuickReportItemAdd(updatedFormData));
      navigate("/quickreportsummary");
      return updatedFormData;
    });
  };

  useEffect(() => {
    dispatch(fetchUsers(quichReportData?.kit_data?.company_id));
    if (injuryType === "single") {
      setFormData((prev) => ({
        ...prev,
        personOfTreatment: {
          value: form_Data?.personOfTreatment?.value ?? "",
          warning: form_Data?.personOfTreatment?.value ? false : true,
        },
      }));
    }
  }, []);

  useEffect(() => {
    const formattedList = usersList.map((user) => {
      return `${user.first_name} ${user.last_name}`;
    });
    setUsers(formattedList);
  }, [usersList]);

  return (
    <div className="quicktwopage flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <div className="mb-3 d-flex justify-content-center">
          <KitImagePreview url={quichReportData?.kit_data?.kit_picture} />
        </div>
        <h6 className="mb-3 fw-bold text-center text-break">
          {quichReportData?.kit_data?.brand}&nbsp;
          {quichReportData?.kit_data?.model_number}&nbsp;
          {quichReportData?.kit_data?.product_name}
        </h6>
        <div className="button_info">
          <ProductDetailsButtonView />
          <hr />
          <div className="item_info">
            <h6 className="fw-bold mb-4">What items were used? </h6>
            <Stack className="row-gap-3">
              {injuryType === "multiple" && (
                <div>
                  <SelectWithTextfield
                    value={formData.personOfTreatment.value ?? ""}
                    onValueChange={(value) =>
                      setFormData((prev) => ({
                        ...prev,
                        personOfTreatment: {
                          value,
                          warning: !value ? true : false,
                        },
                      }))
                    }
                    textProps={{
                      placeholder: "Person of treatment",
                      variant: "outlined",
                      name: "personOfTreatment",
                    }}
                    autoCompleteProps={{ disableClearable: true }}
                    options={users ?? []}
                  />
                  {formData.personOfTreatment.warning && (
                    <p className="text-danger mt-1 mb-0">
                      Select or Type person of treatment
                    </p>
                  )}
                </div>
              )}
              <Form.Group controlId="formBasicItem">
                <Form.Select
                  aria-label="Default select example"
                  className="custom-select-box"
                  value={formData.item.value}
                  name={"item"}
                  onChange={onChange}
                >
                  <option value="" disabled className="option-title">
                    Item
                  </option>
                  {quichReportData &&
                    quichReportData?.products?.map((curElm) => (
                      <option value={curElm.description} key={curElm._id}>
                        {curElm.description}
                      </option>
                    ))}
                </Form.Select>
                {formData.item.warning && (
                  <p className="text-danger mt-1 mb-0">Select item</p>
                )}
              </Form.Group>
              <div>
                <Row className="row-gap-3 gx-3">
                  <Col xs={4} md={3} xxl={2.5}>
                    <Form.Group controlId="formBasicItem">
                      <Form.Label className="d-none"></Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Qty"
                        onChange={onChange}
                        name={"quantity"}
                        className="hide-spinner"
                        value={onChangeToNumber(formData.quantity.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={8} md={9} xxl={9.5}>
                    <Button
                      variant="dark"
                      className="w-100 h-100 fw-bold letter_spacing"
                      onClick={(e) => {
                        validateForm(e);
                      }}
                    >
                      Assign Used Item
                    </Button>
                  </Col>
                </Row>
                {formData.quantity?.warning && (
                  <p className="text-danger mt-1 mb-0">Enter qty</p>
                )}
              </div>
            </Stack>
            {formData?.formDataArray?.length > 0 && (
              <QuantityCard
                setData={setFormData}
                attr={"quickAdd"}
                DataArr={formData?.formDataArray}
                formData={formData}
              />
            )}
          </div>
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink className={"nav-link d-inline"} to="/quickreportinfo">
          <Button variant="dark fw-bold h-100" type="submit">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            variant="primary"
            className="button_custom fw-bold text-black"
            onClick={validateWholeFormValue}
            // disabled={formData?.formDataArray.length === 0 ? true : false}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnlineQuickPageTwo;
